var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhysicalCardBgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 218,
    viewBox: "0 0 343 218",
    width: 343,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#paint0_linear_7429_127170)",
    height: 217.05,
    rx: 11.6518,
    stroke: "url(#paint1_linear_7429_127170)",
    strokeWidth: 0.53033,
    width: 343
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369.974 385.756C246.879 385.756 203.815 304.866 197.07 254.245L277.361 234.924C280.733 257.465 296.558 308.73 371.271 308.73C411.222 308.73 437.035 289.152 437.035 258.882C437.035 234.924 418.226 217.02 386.837 210.967L327.299 199.888C256.607 186.235 212.635 139.092 212.635 76.6206C212.635 0.624775 279.047 -58.8838 364.008 -58.8838C482.822 -58.8838 511.228 19.5598 517.714 49.5718L439.109 71.7262C435.348 56.1405 420.432 18.271 363.359 18.271C323.408 18.271 299.412 44.162 299.412 69.2796C299.412 86.411 307.454 108.307 345.978 115.263L404.217 126.34C479.579 140.251 526.275 188.683 526.275 252.7C526.275 286.447 511.618 319.549 486.195 343.765C466.089 362.957 429.511 385.756 370.104 385.756H369.974Z",
    fill: "url(#paint2_linear_7429_127170)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342.032 -53.5254C400.686 -53.5253 436.982 -34.1592 459.417 -11.125C481.694 11.7469 490.334 38.2691 493.589 53.1416L416.557 74.8623C414.631 67.0692 409.962 54.0163 398.868 42.8369C387.588 31.4702 369.697 22.0713 341.391 22.0713C301.733 22.0713 277.795 47.8019 277.795 72.8945C277.795 81.4232 279.796 91.1646 286.612 99.6416C293.43 108.12 305.029 115.288 324.136 118.74V118.741L381.724 129.698L381.726 129.699C456.12 143.437 502.12 191.233 502.12 254.341C502.12 287.62 487.672 320.273 462.602 344.163H462.601C442.78 363.091 406.699 385.601 348.061 385.602H347.932C287.159 385.601 246.178 365.629 219.559 339.438C193.046 313.351 180.756 281.072 177.367 256.146L256.055 237.203C257.78 248.421 262.587 266.507 276.057 281.865C289.696 297.418 312.182 310.133 349.214 310.133C369.021 310.133 385.362 305.278 396.762 296.632C408.17 287.979 414.606 275.544 414.606 260.457C414.606 236.513 395.806 218.706 364.675 212.699H364.672L305.801 201.739H305.8C236.034 188.258 192.717 141.744 192.717 80.1562C192.717 5.21609 258.185 -53.5254 342.032 -53.5254Z",
    stroke: "white",
    strokeOpacity: 0.05,
    strokeWidth: 0.728238
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376.987 -53.5254C435.641 -53.5253 471.937 -34.1592 494.372 -11.125C516.649 11.7469 525.289 38.2691 528.544 53.1416L451.512 74.8623C449.586 67.0692 444.917 54.0163 433.823 42.8369C422.543 31.4702 404.652 22.0713 376.346 22.0713C336.688 22.0713 312.75 47.8019 312.75 72.8945C312.75 81.4232 314.751 91.1646 321.567 99.6416C328.385 108.12 339.984 115.288 359.091 118.74V118.741L416.679 129.698L416.681 129.699C491.075 143.437 537.075 191.233 537.075 254.341C537.075 287.62 522.627 320.273 497.557 344.163H497.556C477.735 363.091 441.654 385.601 383.016 385.602H382.887C322.114 385.601 281.134 365.629 254.514 339.438C228.001 313.351 215.711 281.072 212.322 256.146L291.01 237.203C292.735 248.421 297.542 266.507 311.012 281.865C324.651 297.418 347.137 310.133 384.169 310.133C403.976 310.133 420.318 305.278 431.717 296.632C443.126 287.979 449.562 275.544 449.562 260.457C449.561 236.513 430.761 218.706 399.63 212.699H399.627L340.756 201.739H340.755C270.989 188.258 227.672 141.744 227.672 80.1562C227.672 5.21609 293.14 -53.5254 376.987 -53.5254Z",
    stroke: "white",
    strokeOpacity: 0.05,
    strokeWidth: 0.728238
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_7429_127170",
    x1: 337.192,
    x2: 0.00000401529,
    y1: 7.33689,
    y2: 211.242
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint1_linear_7429_127170",
    x1: 0.00000162137,
    x2: 343,
    y1: 93.9562,
    y2: 108.525
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "paint2_linear_7429_127170",
    x1: 361.673,
    x2: 361.673,
    y1: -58.8838,
    y2: 385.756
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalCardBgIcon);
export default __webpack_public_path__ + "static/media/PhysicalCardBgIcon.da0d2158634ba42b82f1fa36bf078879.svg";
export { ForwardRef as ReactComponent };